export default "__VITE_ASSET__aEl59D4Q__"